import { render, staticRenderFns } from "./transunion.vue?vue&type=template&id=277ce3f2&scoped=true"
import script from "./transunion.vue?vue&type=script&lang=js"
export * from "./transunion.vue?vue&type=script&lang=js"
import style0 from "./transunion.vue?vue&type=style&index=0&id=277ce3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ce3f2",
  null
  
)

export default component.exports